import { Routes, Route, Navigate } from "react-router-dom";

import { isLoggedIn } from "utils";

import { WELCOME_CONNECTED_PATH } from "features/Auth/routes";
import { nonPremiumRoutes, privateRoutes } from "./namespaces";

export const PrivateRoutes = () => {
  return (
    <Routes>
      {!isLoggedIn() && (
        <Route
          path="*"
          element={
            <Navigate
              to="/signin"
              replace
              state={{ from: location.pathname }}
            />
          }
        />
      )}

      {isLoggedIn() && (
        <>
          {/* {isPremiumUser() && ( */}
          <>
            <Route
              path="*"
              element={
                <Navigate
                  to="/dashboard"
                  replace
                  state={{ from: location.pathname }}
                />
              }
            />

            {privateRoutes.map((route) => (
              <Route
                path={route.path}
                element={route.component}
                key={route.path}
              >
                {route.subRoute?.map((subRoute) => (
                  <Route
                    path={subRoute.path}
                    element={subRoute.component}
                    key={subRoute.path}
                  />
                ))}
              </Route>
            ))}

            {/*) } */}
            {/* {!isPremiumUser() && ( */}
            <>
              <Route
                path="*"
                element={<Navigate to={WELCOME_CONNECTED_PATH} replace />}
              />
              {nonPremiumRoutes.map((route) => (
                <Route
                  path={route.path}
                  element={route.component}
                  key={route.path}
                >
                  {route.subRoute?.map((subRoute) => (
                    <Route
                      path={subRoute.path}
                      element={subRoute.component}
                      key={subRoute.path}
                    />
                  ))}
                </Route>
              ))}
            </>
          </>

          {/* )} */}
        </>
      )}
    </Routes>
  );
};
